import { Row } from 'antd'
import KButton from 'app/components/Modules/General/KButton'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { useKFormContext } from 'app/lib/contexts/KFormContext'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  disabled?: boolean
  onNext?: (interactionType: 'extend' | 'vacant') => void
  onBack?: () => void
  selectedItems: ILineItem[]
  interactionType?: 'extend' | 'vacant'
  step?: number
}

const action = 'update'

const MachineInteractionFooter: React.FC<Props> = ({
  disabled,
  onNext,
  onBack,
  interactionType,
  selectedItems,
  step
}) => {
  const { loading, form } = useKFormContext()
  const {
    confirmfy: { open }
  } = useFeedbacker()
  const recordType =
    interactionType === 'extend' ? RecordType.extend_line_item_request : RecordType.line_item_vacant
  const { tComponent } = useTranslation({
    recordType: RecordType.line_item_vacant,
    componentType: 'feedback',
    scope: 'modal.content'
  })

  const openConfirmDialog = () => {
    open({
      recordType,
      action,
      onConfirm: () => form.submit(),
      values: { count: selectedItems.length.toString() },
      content:
        interactionType === 'vacant' ? tComponent({ id: 'rental_reduction_info' }) : undefined
    })
  }

  return (
    <Choose>
      <When condition={step === 0}>
        <Row gutter={[24, 0]}>
          <KCol span={12}>
            <KButton
              onClick={() => onNext('extend')}
              recordType={RecordType.extend_line_item_request}
              action={action}
              type="primary"
              size="large"
              disabled={disabled}
              block
            />
          </KCol>
          <KCol span={12}>
            <KButton
              onClick={() => onNext('vacant')}
              recordType={RecordType.line_item_vacant}
              action={action}
              type="primary"
              size="large"
              disabled={disabled}
              block
            />
          </KCol>
        </Row>
      </When>
      <Otherwise>
        <Row gutter={[24, 0]}>
          <KCol span={12}>
            <KButton
              onClick={() => onBack()}
              recordType={RecordType.line_item}
              action="back"
              type="secondary"
              size="large"
              block
            />
          </KCol>
          <KCol span={12}>
            <KButton
              recordType={recordType}
              action={action}
              onClick={openConfirmDialog}
              type="primary"
              size="large"
              disabled={disabled}
              loading={loading}
              block
            />
          </KCol>
        </Row>
      </Otherwise>
    </Choose>
  )
}

export default MachineInteractionFooter
